import { phaseInfoForBrique } from '../../utils/phases';

/* Client + phase d'une brique (ou d'une entrée « niveau phase / projet »), dans l'état courant. */
export default function phaseInfoHandlers({ appState }) {
  const getPhaseInfoForBrique = (briqueId, clientId) =>
    phaseInfoForBrique(appState.clients, briqueId, clientId);
  return { getPhaseInfoForBrique };
}
